import {Component, OnInit} from '@angular/core';
import AOS from 'aos';
import {StoreService} from '../../lib/core/common/store/store.service';
import {ChartsService} from '../../services/charts.service';
import {SettingService} from '../../lib/core/common/settings.service';
import {AllAvailableChartDTO} from '../../dto/AllAvailableChartDTO';
import {AvailableChartDTO} from '../../dto/AvailableChartDTO';
import {Page} from '../../lib/core/common/dto/Page';
import {InstagramPostChartDTO} from '../../dto/chart/InstagramPostChartDTO';
import {TikTokPostChartDTO} from '../../dto/chart/TikTokPostChartDTO';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ChartImagesResponseDTO} from '../../dto/ChartImagesResponseDTO';
import {FileManagerService} from '../../lib/files-manager/services/file-manager.service';
import {forkJoin, Observable, ObservableInput} from 'rxjs';
import {HttpResponse} from "@angular/common/http";
import {ChartPageRequest} from "../../dto/chart/ChartPageRequest";

@Component({
  selector: 'app-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.scss'],
})
export class ChartsComponent implements OnInit {
  allAvailableChartDTO: AllAvailableChartDTO = new AllAvailableChartDTO();
  socials: Array<any> = [{
    name: 'Instagram',
    value: 'instagram'
  },
    {
      name: 'TikTok',
      value: 'tiktok'
    }];
  months = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre',
    'Ottobre', 'Novembre', 'Dicembre'];
  protected isWeeklyChecked = true;
  protected isMonthlyChecked = false;
  protected isWeekDisabled = true;
  protected weeklyChartsAvailable: AvailableChartDTO[] = [];
  protected isMonthDisabled = true;
  protected monthlyChartsAvailable: AvailableChartDTO[] = [];
  protected socialSelected = '';
  protected instagramPosts: Array<InstagramPostChartDTO> = [];
  protected tiktokPosts: Array<TikTokPostChartDTO> = [];
  protected weekSelected: '';
  protected monthSelected: '';

  private page = 0;
  private size = 24;
  private totalPages = 0;
  private urlCreator = window.URL || window.webkitURL;
  private instagramChartId: number | undefined;
  private tiktokChartId: number | undefined;

  constructor(public settings: SettingService,
              private sanitizer: DomSanitizer,
              private fileService: FileManagerService,
              private store: StoreService,
              private chartService: ChartsService) {
  }

  ngOnInit() {
    this.settings.enableLoader();
    AOS.init();
    const socialTypeSelected = this.store.getObject('social-type-chart');
    if (socialTypeSelected) {
      this.socialSelected = socialTypeSelected;
    }
    this.setDefault();
  }

  submitWeeklyForm(form: any): void {
    this.instagramPosts = [];
    this.tiktokPosts = [];
    this.page = 0;
    if (form.weekSocial === 'instagram' && form.week) {
      this.instagramChartId = form.week;
      this.retrieveInstagramPostPage();
    }
    if (form.weekSocial === 'tiktok' && form.week) {
      this.tiktokChartId = form.week;
      this.retrieveTikTokPostPage();
    }
  }

  submitMonthlyForm(form: any): void {
    this.instagramPosts = [];
    this.tiktokPosts = [];
    this.page = 0;
    if (form.monthSocial === 'instagram' && form.month) {
      this.instagramChartId = form.month;
      this.retrieveInstagramPostPage();
    }
    if (form.monthSocial === 'tiktok' && form.month) {
      this.tiktokChartId = form.month;
      this.retrieveTikTokPostPage();
    }
  }

  private setDefault(): void {
    this.chartService.getAvailableCharts().subscribe({
      next: res => {
        if (res.body) {
          this.allAvailableChartDTO = res.body;
          this.setWeekList(this.socialSelected);
          this.setMonthList(this.socialSelected);
        }
        this.settings.disableLoader();
      },
      error: err => this.settings.disableLoader()
    });
  }

  private retrieveInstagramPostPage(): void {
    if (this.instagramChartId) {
      this.settings.enableLoader();
      this.getPageInstagramPosts().subscribe({
        next: res => {
          if (res.body) {
            this.prepareRowsInstagram(res.body);
            this.downloadInstagramPostImages(this.instagramPosts);
          }
          this.settings.disableLoader();
        },
        error: err => this.settings.disableLoader()
      });
    }
  }

  private getPageInstagramPosts(): Observable<HttpResponse<Page<InstagramPostChartDTO>>> {
    const chartPageRequest = new ChartPageRequest();
    chartPageRequest
      .setId(this.instagramChartId)
      .setPage(this.page)
      .setSize(this.size);
    return this.chartService.getInstagramChart(this.instagramChartId);
  }

  private retrieveTikTokPostPage(): void {
    if (this.tiktokChartId) {
      this.settings.enableLoader();
      this.getPageTikTokPosts().subscribe({
        next: res => {
          if (res.body) {
            this.prepareRowsTikTok(res.body);
            this.downloadTikTokPostImages(this.tiktokPosts);
          }
          this.settings.disableLoader();
        },
        error: err => this.settings.disableLoader()
      });
    }
  }

  private getPageTikTokPosts(): Observable<HttpResponse<Page<TikTokPostChartDTO>>> {
    const chartPageRequest = new ChartPageRequest();
    chartPageRequest
      .setId(this.tiktokChartId)
      .setPage(this.page)
      .setSize(this.size);
    return this.chartService.getTikTokChart(this.tiktokChartId);
  }

  protected onChangeWeekSocial($event: Event, form: any) {
    const value = ($event.target as HTMLInputElement).value;
    this.socialSelected = value;
    this.setWeekList(value);
    this.weekSelected = null;
    this.instagramPosts = [];
    this.tiktokPosts = [];
  }

  protected onChangeMonthSocial($event: Event, form: any) {
    const value = ($event.target as HTMLInputElement).value;
    this.socialSelected = value;
    this.setMonthList(value);
    this.monthSelected = null;
    this.instagramPosts = [];
    this.tiktokPosts = [];
  }

  protected getMonthFromDate(dateFrom: Date) {
    dateFrom = new Date(dateFrom);
    return this.months[dateFrom.getMonth()];
  }

  private setWeekList(value: string) {
    if (value) {
      this.isWeekDisabled = false;
      if (value === 'instagram') {
        this.weeklyChartsAvailable = this.allAvailableChartDTO.weeklyInstagramChart;
      }
      if (value === 'tiktok') {
        this.weeklyChartsAvailable = this.allAvailableChartDTO.weeklyTikTokChart;
      }
    }
  }

  private setMonthList(value: string) {
    if (value) {
      this.isMonthDisabled = false;
      if (value === 'instagram') {
        this.monthlyChartsAvailable = this.allAvailableChartDTO.monthlyInstagramChart;
      }
      if (value === 'tiktok') {
        this.monthlyChartsAvailable = this.allAvailableChartDTO.monthlyTikTokChart;
      }
    }
  }

  protected getPostDate(postDate: Date) {
    postDate = new Date(postDate);
    return postDate.getDate().toString() + ' ' + this.months[postDate.getMonth()] + ' ' +
      postDate.getFullYear().toString() + ' alle ';
  }

  private setPostImageUrl(res: Array<Blob>, responseMap: Array<ChartImagesResponseDTO>, key: string): SafeResourceUrl {
    return this.setImageUrl(res, responseMap, key, 'assets/img/preview-not-available.jpg');
  }

  private setInfluencerImageUrl(res: Array<Blob>, responseMap: Array<ChartImagesResponseDTO>, key: string): SafeResourceUrl {
    return this.setImageUrl(res, responseMap, key, 'assets/img/influencer-preview-not-available.jpeg');
  }

  private setImageUrl(res: Array<Blob>,
                      responseMap: Array<ChartImagesResponseDTO>,
                      key: string,
                      defaultImageUrl: string): SafeResourceUrl {
    const response = responseMap.find(homeChartImagesResponse => homeChartImagesResponse.key === key);
    if (response) {
      const resBlob = res[response.responsePosition];
      if (resBlob) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(this.urlCreator.createObjectURL(resBlob));
      } else {
        return this.sanitizer.bypassSecurityTrustResourceUrl(defaultImageUrl);
      }
    } else {
      return this.sanitizer.bypassSecurityTrustResourceUrl(defaultImageUrl);
    }
  }

  private downloadInstagramPostImages(instagramPosts: Array<InstagramPostChartDTO>): void {
    if (instagramPosts.length > 0) {
      const observableInput: Array<ObservableInput<Blob>> = [];
      const responseMap: Array<ChartImagesResponseDTO> = [];
      instagramPosts.forEach(post => {
        this.validateAndRetrieveObservableInput(
          observableInput,
          post.instagramPostDTO?.previewFileId,
          responseMap,
          'previewFile-' + post.instagramPostDTO?.previewFileId?.toString());
        this.validateAndRetrieveObservableInput(
          observableInput,
          post.instagramPostDTO?.influencerDTO?.avatarFileId,
          responseMap,
          'avatarFile-' + post.instagramPostDTO?.influencerDTO?.avatarFileId?.toString());
      });
      forkJoin(observableInput).subscribe((res: Array<Blob>) => {
        instagramPosts.forEach(post => {
          post.instagramPostDTO.previewLink = this.setPostImageUrl(
            res, responseMap, 'previewFile-' + post.instagramPostDTO?.previewFileId?.toString());
          post.instagramPostDTO.influencerDTO.avatarLink = this.setInfluencerImageUrl(
            res, responseMap, 'avatarFile-' + post.instagramPostDTO?.influencerDTO?.avatarFileId?.toString());
        });
        this.settings.disableLoader();
      });
    } else {
      this.settings.disableLoader();
    }
  }

  private downloadTikTokPostImages(tiktokPosts: Array<TikTokPostChartDTO>): void {
    if (tiktokPosts.length > 0) {
      const observableInput: Array<ObservableInput<Blob>> = [];
      const responseMap: Array<ChartImagesResponseDTO> = [];
      tiktokPosts.forEach(post => {
        this.validateAndRetrieveObservableInput(
          observableInput,
          post.tikTokPostDTO?.previewFileId,
          responseMap,
          'previewFile-' + post.tikTokPostDTO?.previewFileId.toString());
        this.validateAndRetrieveObservableInput(
          observableInput,
          post.tikTokPostDTO?.influencerDTO?.avatarFileId,
          responseMap,
          'avatarFile-' + post.tikTokPostDTO?.influencerDTO?.avatarFileId?.toString());
      });
      forkJoin(observableInput).subscribe((res: Array<Blob>) => {
        tiktokPosts.forEach(post => {
          post.tikTokPostDTO.previewLink = this.setPostImageUrl(
            res, responseMap, 'previewFile-' + post.tikTokPostDTO?.previewFileId?.toString());
          post.tikTokPostDTO.influencerDTO.avatarLink = this.setInfluencerImageUrl(
            res, responseMap, 'avatarFile-' + post.tikTokPostDTO?.influencerDTO?.avatarFileId?.toString());
        });
        this.settings.disableLoader();
      });
    } else {
      this.settings.disableLoader();
    }
  }

  private validateAndRetrieveObservableInput(
    observableInput: Array<ObservableInput<Blob>>,
    fileId: number,
    responseMap: Array<ChartImagesResponseDTO>,
    key: string): void {
    if (fileId) {
      observableInput.push(this.fileService.download(fileId, 'resources'));
      const response: ChartImagesResponseDTO = new ChartImagesResponseDTO();
      response.key = key;
      response.responsePosition = observableInput.length - 1;
      responseMap.push(response);
    }
  }

  protected onScrollInstagramPost() {
    if (this.page < this.totalPages - 1) {
      this.page++;
      this.retrieveInstagramPostPage();
    }
  }

  protected onScrollTikTokPost() {
    if (this.page < this.totalPages - 1) {
      this.page++;
      this.retrieveTikTokPostPage();
    }
  }

  private prepareRowsInstagram(page: Page<InstagramPostChartDTO>): void {
    if (page) {
      this.totalPages = page.totalPages;
      this.instagramPosts = page.content;
    }
  }

  private prepareRowsTikTok(page: Page<TikTokPostChartDTO>): void {
    if (page) {
      this.totalPages = page.totalPages;
      this.tiktokPosts = page.content;
    }
  }
}
